import { useState } from "react";
import { faqs } from "@/mocks/games";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-2 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
          FAQ
        </p>
        <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          常见问题解答
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
          关于同人游戏下载、安装与运行的常见疑问，这里一次性说清楚。
        </p>
      </div>

      <div className="mt-10 space-y-4">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return (
            <div
              key={faq.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                    <i className="ri-question-line"></i>
                  </span>
                  <h3 className="text-sm font-bold text-foreground-900 md:text-base">
                    {faq.q}
                  </h3>
                </span>
                <i
                  className={`${
                    isOpen ? "ri-subtract-line" : "ri-add-line"
                  } shrink-0 text-xl text-primary-500 transition-transform`}
                ></i>
              </button>
              {isOpen && (
                <div className="border-t border-background-200 px-5 py-4">
                  <p className="pl-11 text-sm leading-7 text-foreground-600">{faq.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8 rounded-lg bg-primary-100/70 p-5 text-center">
        <p className="text-sm text-primary-900">
          没找到想要的答案？可以留言反馈，我们会尽快补充对应问题的指引。
        </p>
      </div>
    </section>
  );
}